/** Statisk bolagsdata för diagram i SlideContent-förhandsvisningar (designval). */

interface ProfitLossSheet {
  DATE_TO: string;
  A: number;
  K: number;
  B?: number;
  D?: number;
  F?: number;
  G?: number;
  H?: number;
  J?: number;
  L?: number;
  M?: number;
  O?: number;
  Q?: number;
  R?: number;
}

function profitLossSheet(
  year: number,
  netSales: number,
  operatingResult: number,
  extra: Partial<ProfitLossSheet> = {},
): ProfitLossSheet {
  return {
    DATE_TO: `${year}-12-31`,
    A: netSales,
    K: operatingResult,
    ...extra,
  };
}

const profitlossSheets: ProfitLossSheet[] = [
  profitLossSheet(2024, 11500, 1265, {
    B: 180,
    D: -4100,
    F: -2050,
    G: -3650,
    H: -480,
    J: -420,
    L: -85,
    M: -35,
    O: 95,
    Q: -280,
    R: 1315,
  }),
  profitLossSheet(2023, 10800, 1080),
  profitLossSheet(2022, 10100, 939),
  profitLossSheet(2021, 9200, 828),
  profitLossSheet(2020, 8500, 765),
];

export const PREVIEW_COMPANY_DATA = {
  profitloss: {
    sheets: profitlossSheets,
  },
  balance: {
    sheets: [],
  },
  cashflow: {
    sheets: [],
  },
};

export function getPreviewProfitLossSheet(): ProfitLossSheet {
  return profitlossSheets[0];
}
